import { styled } from '@mui/system'

export const Cell = styled('div')`
    min-height: 60px;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    cursor: pointer;
`
